/**
 * /table · ExamplePrompts — six lyrical prompts under the search bar.
 *
 * The single biggest "this feels human" win: gives members permission
 * to type naturally. Click any chip → prefill the search bar AND fire
 * the search (so the result is immediate, not just suggestive).
 *
 * Why these specific six: each maps to a distinct backend path
 * (free-text, parse-query → /browse with city, cuisine + budget,
 * authority, near-me-prompt, occasion). Members see the shape of
 * what's possible without us listing capabilities.
 */
import React from "react";

const PROMPTS = [
    "Best omakase in Tokyo",
    "Michelin under £100 London",
    "Late-night dinner Mumbai",
    "World's 50 Best bars Dubai",
    "Quiet anniversary table Paris",
    "Family Sunday lunch Goa",
];

export function ExamplePrompts({ onPick }) {
    return (
        <div
            data-testid="example-prompts"
            className="t-rise"
            style={{
                animationDelay: "0.22s",
                marginTop: 14,
                display: "flex",
                flexWrap: "wrap",
                gap: 8,
                justifyContent: "center",
            }}
        >
            {PROMPTS.map((p, i) => (
                <button
                    key={p}
                    type="button"
                    data-testid={`example-prompt-${i}`}
                    onClick={() => onPick?.(p)}
                    style={{
                        background: "transparent",
                        color: "var(--t-ink2)",
                        border: "1px solid var(--t-line2)",
                        borderRadius: 999,
                        padding: "7px 14px",
                        fontSize: 12.5,
                        fontFamily: "'Hanken Grotesk', system-ui, sans-serif",
                        cursor: "pointer",
                        transition: "all 0.15s",
                        whiteSpace: "nowrap",
                    }}
                    onMouseEnter={(e) => {
                        e.currentTarget.style.background = "var(--t-card)";
                        e.currentTarget.style.borderColor = "var(--t-brass2)";
                        e.currentTarget.style.color = "var(--t-ink)";
                    }}
                    onMouseLeave={(e) => {
                        e.currentTarget.style.background = "transparent";
                        e.currentTarget.style.borderColor = "var(--t-line2)";
                        e.currentTarget.style.color = "var(--t-ink2)";
                    }}
                >
                    {p}
                </button>
            ))}
        </div>
    );
}
